module.exports = __webpack_public_path__ + "static/media/Duvida.f7ff870e.svg";